var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKeeperSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167,
    height: 153,
    viewBox: "0 0 167 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9851",
    "data-name": "Group 9851",
    transform: "translate(-970 -304)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6050",
    "data-name": "Rectangle 6050",
    width: 167,
    height: 153,
    rx: 10,
    transform: "translate(970 304)",
    fill: "#020e72"
  }), /*#__PURE__*/React.createElement("g", {
    id: "american-football-player-svgrepo-com",
    transform: "translate(1020 332.315)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80133",
    "data-name": "Path 80133",
    d: "M176.963,125.944a6.653,6.653,0,0,0-4.133.268,6.22,6.22,0,0,0-1.522.9,16.9,16.9,0,0,1,4.285.87C176.049,127.246,176.5,126.564,176.963,125.944Z",
    transform: "translate(-149.105 -104.502)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80134",
    "data-name": "Path 80134",
    d: "M198.26,124.693c-1.887-1.028-3.292-1.5-4.534-1.291q.536.447,1.047.957a1.689,1.689,0,0,1-2.389,2.389,11.8,11.8,0,0,0-1.583-1.333,19.808,19.808,0,0,0-1.408,1.985c.371.21.7.413.972.594,1.009.664,4.3,3.031,4.3,5.588s-3.29,4.923-4.3,5.588a18.007,18.007,0,0,1-6.195,2.565,6.626,6.626,0,0,0,3.212,2.952c4.1,2.223,6.542,1.813,11.053-6.488.769-1.413,1.455-2.694,2.021-3.855.014-.033.031-.064.047-.1a13.429,13.429,0,0,0,1.587-4.838C202.148,128.073,201.724,126.578,198.26,124.693Z",
    transform: "translate(-159.796 -102.519)",
    fill: "#b3e697"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80135",
    "data-name": "Path 80135",
    d: "M124.042,158.77c-.314-1.14-4.574-5.11-10.385-5.11-.407,0-.8.021-1.2.058a12.578,12.578,0,0,0-.649,4.167,1.689,1.689,0,0,1-3.378,0,17.006,17.006,0,0,1,.308-3.272c-3.171,1.249-5.254,3.373-5.47,4.157.314,1.14,4.574,5.11,10.385,5.11S123.728,159.91,124.042,158.77Z",
    transform: "translate(-92.559 -127.709)",
    fill: "#e85512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80136",
    "data-name": "Path 80136",
    d: "M315.773,72.588a6.453,6.453,0,0,0,4.515-4.515h-4.515Z",
    transform: "translate(-269.172 -56.576)",
    fill: "#ffebd4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80137",
    "data-name": "Path 80137",
    d: "M277.352,20.867a6.429,6.429,0,1,0-4.917,11.764v-6.2a1.689,1.689,0,0,1,1.689-1.689h6.2A6.449,6.449,0,0,0,277.352,20.867Z",
    transform: "translate(-229.212 -16.622)",
    fill: "#e85512"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80138",
    "data-name": "Path 80138",
    d: "M98.611,125.793a1.688,1.688,0,0,0-2-1.3c-5.092,1.086-9.877-1.238-12.662-6.085a14.934,14.934,0,0,0,1.566-5.4c.183-4.193-3.1-6.477-5.589-7.83-3.462-1.885-6.181-2.225-8.557-1.069a7.435,7.435,0,0,0-1.04.622,10.337,10.337,0,0,0-8.05-.17,9.85,9.85,0,0,0-4.827,4.364,18.02,18.02,0,0,0-5.98,2.521c-1.008.664-4.3,3.031-4.3,5.588s3.29,4.923,4.3,5.588a17.569,17.569,0,0,0,9.3,2.9,6.947,6.947,0,0,0,.648,1.629c-2.939,3.225-13.292,14.565-21.121,22.931a1.69,1.69,0,0,0-.456,1.154v5.313a1.689,1.689,0,1,0,3.378,0V151.9c7.567-8.1,17.254-18.7,20.44-22.2a14.929,14.929,0,0,0,2.159,1.4,11.837,11.837,0,0,0,4.533,1.514,6.578,6.578,0,0,1,3.517,7.68c-.7,2.853-3.4,6.1-8.714,5.864a1.689,1.689,0,0,0-1.76,1.794l.355,5.619a1.689,1.689,0,0,0,1.684,1.582q.054,0,.108,0a1.689,1.689,0,0,0,1.579-1.792l-.244-3.858a11.207,11.207,0,0,0,10.273-8.4,9.946,9.946,0,0,0-2.464-9.454c2.51-1.463,4.619-4.442,6.763-8.386.257-.472.5-.929.743-1.377a15.876,15.876,0,0,0,5.155,4.541,14.078,14.078,0,0,0,6.757,1.709,15.358,15.358,0,0,0,3.207-.344A1.689,1.689,0,0,0,98.611,125.793ZM80.5,117.8c-.565,1.161-1.251,2.442-2.021,3.855-4.511,8.3-6.953,8.711-11.053,6.488a6.627,6.627,0,0,1-3.212-2.952,18.005,18.005,0,0,0,6.195-2.565c1.008-.664,4.3-3.031,4.3-5.588s-3.29-4.923-4.3-5.588c-.275-.181-.6-.383-.972-.594a19.834,19.834,0,0,1,1.408-1.985,11.809,11.809,0,0,1,1.583,1.333,1.689,1.689,0,1,0,2.389-2.389q-.51-.51-1.047-.957c1.242-.212,2.647.263,4.534,1.291,3.464,1.885,3.888,3.38,3.829,4.716a13.428,13.428,0,0,1-1.587,4.838C80.533,117.734,80.517,117.765,80.5,117.8Zm-29.948-.762c.216-.784,2.3-2.908,5.47-4.157a16.994,16.994,0,0,0-.308,3.272,1.689,1.689,0,1,0,3.378,0,12.578,12.578,0,0,1,.649-4.167c.391-.037.789-.058,1.2-.058,5.811,0,10.072,3.971,10.385,5.11-.314,1.14-4.574,5.11-10.385,5.11S50.868,118.176,50.555,117.036Zm13.012-9.352a6.653,6.653,0,0,1,4.133-.268c-.461.62-.914,1.3-1.37,2.041a16.9,16.9,0,0,0-4.285-.87A6.215,6.215,0,0,1,63.567,107.685Z",
    transform: "translate(-39.842 -85.974)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80139",
    "data-name": "Path 80139",
    d: "M252.573,18.287a9.818,9.818,0,0,0,4.462,1.314l6.934,3.821a1.689,1.689,0,1,0,1.63-2.958L262.033,18.5A9.816,9.816,0,0,0,267.3,9.835c0-.009,0-.018,0-.027,0-.04,0-.081,0-.12a9.806,9.806,0,0,0-18.285-4.806,9.806,9.806,0,0,0,3.56,13.406Zm6.61-2.276V11.5H263.7A6.453,6.453,0,0,1,259.183,16.011Zm-1.689-7.892a1.689,1.689,0,0,0-1.689,1.689v6.2a6.454,6.454,0,0,1-1.537-.643,6.428,6.428,0,0,1-2.333-8.789,6.424,6.424,0,0,1,11.759,1.542h-6.2Z",
    transform: "translate(-212.582 0)",
    fill: "#fff"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKeeperSelected);
export default __webpack_public_path__ + "static/media/keeper-selected.57353933f34bbfd6fd2c172a14d36212.svg";
export { ForwardRef as ReactComponent };